import styled from 'styled-components'
import posed from 'react-pose';
import { Link } from 'react-router-dom'

export const HeaderStyled = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 5px 0;
    background: ${({ theme }) => theme.grassyGreen};
    z-index: 1;
`

export const HeaderContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
export const Logo = styled(Link)`
    display: flex;
`

export const StyledVersion = styled.span`
    font-size: 14px;
    color:  ${({ theme }) => theme.whiteTwo};
`

export const RightPanel = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
`

export const LanguagesWrapper = styled.div`
    position: relative;
    text-transform: uppercase;
    z-index: 3;
`

export const CurrentLanguage = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 40px;
    padding: 5px 20px 5px 5px;
    color: ${({ theme }) => theme.white};
    cursor: pointer;
    &:after {
        content: '';
        position: absolute;
        top: 16px;
        right: 10px;
        width: 6px;
        height: 6px;
        border-right: 2px solid ${({ theme }) => theme.white};
        border-bottom: 2px solid ${({ theme }) => theme.white};
        transform: rotate(45deg)
    }
`

const LanguagesPosed = posed.div({
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            y: { type: 'spring', stiffness: 200, damping: 10 },
            duration: 300
        }
    },
    exit: {
        y: 10,
        opacity: 0,
        transition: {
            duration: 300
        }
    }
});

export const Languages = styled(LanguagesPosed)`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 0;
    background: ${({ theme }) => theme.grassyGreen};
    border: 1px solid ${({ theme }) => theme.white};
    box-shadow: 0 2px 4px 0 ${({ theme }) => theme.blueyGrey22};
    border-radius: 4px;
`

export const Language = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 5px;
    text-align: center;
    color: ${({ theme }) => theme.white};
    cursor: pointer;
    border-bottom: 1px solid ${({ theme }) => theme.white};
    &:last-child {
        border-bottom: none;
    }
`

export const Logout = styled.div`
   margin-left: 20px;
   cursor: pointer;
`
